/** Recurring series guests can follow for schedule updates and RSVP reminders. */
export function canFollowSeries(event) {
  if (!event) return false;
  const pattern = event.recurring;
  return Boolean(pattern && pattern !== "none");
}
